const dev = false;
export const BASE_URL = !dev
  ? "https://api.flashdocs.ai/v1"
  : "https://flashdocs2.ngrok.dev/v1";
export const BASE_URL2 = !dev
  ? "https://api.flashdocs.ai/v2"
  : "https://flashdocs2.ngrok.dev/v2";

export const setAuthToken = (token: string) => {
  //console.log("Setting auth token in localStorage");
  localStorage.setItem("jwt_token", token);
};

export const getAuthToken = () => {
  const token = localStorage.getItem("jwt_token");
  //console.log(
  //  "Retrieved auth token from localStorage:",
  //  token ? "Token exists" : "No token"
  //);
  return token;
};

export const removeAuthToken = () => {
  //console.log("Removing auth token from localStorage");
  localStorage.removeItem("jwt_token");
};

export const setUserEmail = (email: string) => {
  //console.log("Setting user email in localStorage");
  localStorage.setItem("user_email", email);
};

export const getUserEmail = () => {
  const email = localStorage.getItem("user_email");
  //console.log(
  //   "Retrieved user email from localStorage:",
  //   email ? "Email exists" : "No email"
  // );
  return email;
};

export const removeUserEmail = () => {
  //console.log("Removing user email from localStorage");
  localStorage.removeItem("user_email");
};

export const setGoogleAccessToken = (token: string) => {
  //console.log("Setting Google access token in localStorage");
  localStorage.setItem("google_access_token", token);
};

export const getGoogleAccessToken = () => {
  const token = localStorage.getItem("google_access_token");
  return token;
};

export const removeGoogleAccessToken = () => {
  //console.log("Removing Google access token from localStorage");
  localStorage.removeItem("google_access_token");
};

export const setGoogleRefreshToken = (token: string) => {
  //console.log("Setting Google refresh token in localStorage");
  localStorage.setItem("google_refresh_token", token);
};

export const getGoogleRefreshToken = () => {
  const token = localStorage.getItem("google_refresh_token");
  return token;
};

export const removeGoogleRefreshToken = () => {
  //console.log("Removing Google refresh token from localStorage");
  localStorage.removeItem("google_refresh_token");
};
